/**
 * 登录相关接口
 */

import { instance } from '../index';

const defaultConfig = {
  bodyType: 'form'
};

// 进门方式登录
export const getMainLineToken = async (data, config) => {
  return await instance.post('/api/admin/user/mainLine/token', data, {
    ...config,
    defaultConfig
  });
};

// 海外登录
export const overseasLogin = async (data, config) => {
  return await instance.post('/user/auth/login', data, config);
};
